import { X } from "lucide-react";

const KATEGORIER = [
  { navn: "Vanlige", emojis: "📄 📌 🎯 🚀 💡 ⭐ 🔥 ✅ 📊 📈 🗂️ 🧭 🎤 🤝 🧠 🤖 🏔️ 🇳🇴 ✨ 🏆".split(" ") },
  { navn: "Arbeid", emojis: "💼 📅 📝 📋 📎 🗓️ 💰 💳 📧 📞 🖥️ ⌨️ 🔑 🔒 🔍 ⚙️ 🛠️ 📦 🏗️ 🧾 📑 🗃️ 📇 ⏰ ⏳ 📣".split(" ") },
  { navn: "Smilefjes", emojis: "😀 😄 😊 🙂 😉 😍 🤩 😎 🤓 🧐 🤔 😅 😂 🥳 😴 🤯 🫡 🤫 🙌 👏 💪 🙏 👍 👎 👋 🤞".split(" ") },
  { navn: "Natur", emojis: "🌍 🌊 ⛰️ 🌲 🌳 🍀 🌸 🌞 🌙 ⚡ ❄️ 🌈 🌧️ 🦅 🐋 🦊 🐻".split(" ") },
  { navn: "Mat & drikke", emojis: "☕ 🍵 🥐 🍕 🍣 🥗 🍎 🍇 🍫 🍷 🍾 🥂 🍺 🧁 🍿".split(" ") },
  { navn: "Reise", emojis: "✈️ 🚆 🚢 ⛴️ 🚗 🗺️ 🧳 🏨 🏛️ 🌉 🗼 ⚓".split(" ") },
  { navn: "Symboler", emojis: "❤️ 🧡 💛 💚 💙 🖤 🤍 💯 ✔️ ❌ ⚠️ ❗ ❓ 💬 💭 🔔 🎉 🎊 🎁 🏅 🥇 🥈 🥉 ♻️".split(" ") },
];

export function EmojiVelger({ harIkon, onVelg, onFjern, onLukk }) {
  return (
    <>
      <div className="fixed inset-0 z-40" onClick={onLukk} data-testid="dok-emoji-backdrop" />
      <div className="dok-emoji-velger" data-testid="dok-emoji-velger">
        <div className="flex items-center justify-between px-2.5 pt-2 pb-1">
          <p className="dok-velger-tittel !p-0">Velg ikon</p>
          <div className="flex items-center gap-1.5">
            {harIkon && (
              <button type="button" onClick={onFjern} className="dok-velger-fjern" data-testid="dok-emoji-fjern">Fjern</button>
            )}
            <button type="button" onClick={onLukk} className="text-neutral-400 hover:text-neutral-800 transition-colors" data-testid="dok-emoji-lukk">
              <X size={13} />
            </button>
          </div>
        </div>
        <div className="dok-emoji-scroll">
          {KATEGORIER.map((k) => (
            <div key={k.navn}>
              <p className="dok-emoji-kat">{k.navn}</p>
              <div className="dok-emoji-grid">
                {k.emojis.map((e) => (
                  <button key={e} type="button" onClick={() => onVelg(e)} className="dok-emoji-knapp" data-testid={`dok-emoji-${e}`}>
                    {e}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
